import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import ValidationError from '../ValidationError/ValidationError';
import CountrySelect from '../CountrySelect/CountrySelect';

import css from './FieldCountrySelect.module.css';

const FieldCountrySelectComponent = props => {
  const {
    rootClassName,
    className,
    id,
    label,
    input,
    meta,
    locale,
    placeholder,
    intl,
    ...rest
  } = props;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { valid, invalid, touched, error } = meta;

  const hasError = touched && invalid && error;

  const handleChange = value => {
    input.onChange(value);
  };

  const handleBlur = () => {
    input.onBlur();
  };

  const classes = classNames(rootClassName || css.root, className, {
    [css.fieldError]: hasError,
  });

  return (
    <div className={classes}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      <CountrySelect
        id={id}
        name={input.name}
        value={input.value || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        locale={locale}
        placeholder={placeholder}
        intl={intl}
        hasError={hasError}
        {...rest}
      />
      <ValidationError fieldMeta={meta} />
    </div>
  );
};

FieldCountrySelectComponent.defaultProps = {
  rootClassName: null,
  className: null,
  id: null,
  label: null,
  locale: 'en',
};

const { string, object } = PropTypes;

FieldCountrySelectComponent.propTypes = {
  rootClassName: string,
  className: string,

  id: string,
  label: string,

  locale: string,

  placeholder: string,

  intl: object,

  input: object.isRequired,
  meta: object.isRequired,
};

const FieldCountrySelect = props => {
  return <Field component={FieldCountrySelectComponent} {...props} />;
};

export default FieldCountrySelect;
